/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyOfficeAssociateOfficesToUserDto } from '../../models/company-office-associate-offices-to-user-dto';
import { EmptyResponse } from '../../models/empty-response';

export interface OfficeControllerDissociateOfficesFromUser$Params {
  id: number;
      body: CompanyOfficeAssociateOfficesToUserDto
}

export function officeControllerDissociateOfficesFromUser(http: HttpClient, rootUrl: string, params: OfficeControllerDissociateOfficesFromUser$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerDissociateOfficesFromUser.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EmptyResponse;
      }>;
    })
  );
}

officeControllerDissociateOfficesFromUser.PATH = '/company/office/associate/user/{id}/offices';
